import { useState, useEffect } from "react";

import { FiChevronRight } from "react-icons/fi";
import { FiChevronsRight } from "react-icons/fi";

import colors from "assets/theme/base/colors";

import { Container, PageLabel, ArrowLeft, ArrowsLeft, ArrowRight, ArrowsRight } from "./styles";

function Pagination({ currentPage = 1, totalPages = 0, onChange = () => {} }) {
  const [current, setCurrent] = useState(currentPage);
  const [pages, setPages] = useState(1);

  const pageActive = ["", "", "", "", ""];
  const pageLabel = [1, 2, 3, 4, 5];

  pageActive[current] = "active";

  const nextPage = () => {
    if (current >= totalPages) return current;
    console.log(">>> nextPage:", current, totalPages);
    setCurrent(current + 1);
    onChange(current + 1);
  };

  const nextPrevius = () => {
    if (current <= 1) return current;
    setCurrent(current - 1);
    onChange(current - 1);
  };

  return (
    <Container>
      <ArrowsLeft
        onClick={() => {
          setCurrent(1);
          onChange(1);
        }}
      />
      <ArrowLeft onClick={nextPrevius} />
      <PageLabel>
        {current}/{totalPages}
      </PageLabel>
      <ArrowRight onClick={nextPage} />
      <ArrowsRight
        onClick={() => {
          setCurrent(totalPages);
          onChange(totalPages);
        }}
      />

      {/*  */}
      {/* <ul class="pagination">
        <li onClick={nextPrevius}>
          <a href="#" style={{ marginLeft: 10, cursor: "pointer" }}>
            &laquo;
          </a>
        </li>
        <li>
          <a href="#" className={pageActive[0]}>
            {pageLabel[0] * pages}
          </a>
        </li>
        <li>
          <a href="#" className={pageActive[1]}>
            {pageLabel[1] * pages}
          </a>
        </li>
        <li>
          <a href="#" className={pageActive[2]}>
            {pageLabel[2] * pages}
          </a>
        </li>
        <li>
          <a href="#" className={pageActive[3]}>
            {pageLabel[3] * pages}
          </a>
        </li>
        <li>
          <a href="#" className={pageActive[4]}>
            {pageLabel[4] * pages}
          </a>
        </li>
        <li onClick={nextPage}>
          <a href="#" style={{ marginLeft: 10, cursor: "pointer" }}>
            &raquo;
          </a>
        </li>
      </ul> */}
    </Container>
  );
}

export default Pagination;
